module.exports = __webpack_public_path__ + "static/assets/8c6be33fc9a8eadffa880c9fe0ca6340.png";